const HomeView = () => import(/* webpackChunkName: "h" */ '@/views/HomeView');
// const VideoGalleryView = () => import(/* webpackChunkName: "v" */ '@/views/VideoGalleryView');
const WeatherView = () => import(/* webpackChunkName: "w" */ '@/views/WeatherView');
const AnnouncementView = () => import(/* webpackChunkName: "an" */ '@/views/AnnouncementView');

const TravelAgencyMainView = () => import(/* webpackChunkName: "t" */ '@/views/TravelAgencyMainView');
const TravelAgencySearchView = () => import(/* webpackChunkName: "ts" */ '@/views/TravelAgencySearchView');


const AccommodationView = () => import(/* webpackChunkName: "a" */'@/views/AccommodationView');
const AccommodationMainView = () => import(/* webpackChunkName: "am" */'@/views/AccommodationMainView');

const EventView = () => import(/* webpackChunkName: "e" */'@/views/EventView');
const EventMainView = () => import(/* webpackChunkName: "em" */'@/views/EventMainView');
const EventCalendarView = () => import(/* webpackChunkName: "ec" */'@/views/EventCalendarView');


const DiningView = () => import(/* webpackChunkName: "d" */'@/views/DiningView');
const DiningMainView = () => import(/* webpackChunkName: "dm" */'@/views/DiningMainView');
const DiningSearchAllRestaurantView = () => import(/* webpackChunkName: "dsa" */'@/views/DiningSearchAllRestaurantView');

const AccessibilityView = () => import(/* webpackChunkName: "ab" */'@/views/AccessibilityView');

const TravelEssentialView = () => import(/* webpackChunkName: "ee" */'@/views/TravelEssentialView');
const BorderCheckpointsView = () => import(/* webpackChunkName: "ee" */'@/views/BorderCheckpointsView');
const createTravelEssentialArticleView = (category) => () =>
  import(/* webpackChunkName: "eea" */'@/views/CreateTravelEssentialArticleView')
    .then(m => m.default(category));
const TouristInformationView = () => import(/* webpackChunkName: "eet" */'@/views/TouristInformationView');
const DelegationView = () => import(/* webpackChunkName: "eed" */'@/views/DelegationView');
const RepresentativeView = () => import(/* webpackChunkName: "eer" */'@/views/RepresentativeView');
const BrochuresView = () => import(/* webpackChunkName: "eeb" */'@/views/BrochuresView');

const ArticleView = () => import(/* webpackChunkName: "aa" */'@/views/ArticleView');
const ArticleWithCategoryView = () => import(/* webpackChunkName: "aac" */'@/views/ArticleWithCategoryView');

const VideoPlaylistsView = () => import('@/views/VideoPlaylistsView');

const WhatsonView = () => import(/* webpackChunkName: "wson" */'@/views/WhatsonView');
const WhatsonDownloadView = () => import(/* webpackChunkName: "wsond" */'@/views/WhatsonDownloadView');

const HalalTravelGuideView = () => import(/* webpackChunkName: "halaltg" */'@/views/HalalTravelGuideView');

const RedirectToView = () => import(/* webpackChunkName: "redirto" */'@/views/RedirectToView');

/**
 * Pending until API ready
 * */
// const BlogView = () => import(/* webpackChunkName: "bg" */'@/views/BlogView');
// const BlogArticleView = () => import(/* webpackChunkName: "bga" */'@/views/BlogArticleView');

/**
 * Main Router
 *
 * all routes beside the sightmap part
 */
const mainRoutes = [
  {
    path: '',
    name: 'Home',
    component: HomeView,
  },
  {
    path: 'events',
    component: EventView,
    children: [
      {
        path: '',
        name: 'EventMain',
        component: EventMainView,
      },
      {
        path: 'calendar',
        name: 'EventCalendar',
        component: EventCalendarView,
      },
    ]
  },
  {
    path: 'weather',
    name: 'Weather',
    component: WeatherView,
  },
  {
    path: 'announcement',
    name: 'Announcement',
    component: AnnouncementView,
  },
  {
    path: 'barrier-free-access-guide',
    name: 'Accessibility',
    component: AccessibilityView
  },
  /**
   * Pending until API ready
   */
  // {
  //   path: 'blog',
  //   name: 'Blog',
  //   component: BlogView,
  // },
  // {
  //   path: 'blog/:star',
  //   name: 'BlogStar',
  //   component: BlogView,
  // },
  // {
  //   path: 'blog/:star/:slug',
  //   name: 'BlogArticle',
  //   component: BlogArticleView,
  // },
  {
    path: 'travelagencies',
    component: {
      name: 'travelagencies-wrapper',
      render: function(h) {
        return <router-view />
      }
    },
    children: [
      {
        path: '',
        redirect: '/travelessential/before-you-travel/travel-agencies',
      },
      {
        path: 'search',
        name:'TravelAgencySearch',
        component: TravelAgencySearchView
      }
    ]
  },
  {
    path: 'travelessential',
    name: 'TravelEssential',
    component: TravelEssentialView
  },
  {
    path: 'travelessential/before-you-travel',
    redirect: {
      path: 'travelessential',
      hash: '#before-you-travel'
    }
  },
  {
    path: 'travelessential/useful-info',
    redirect: {
      path: 'travelessential',
      hash: '#useful-info'
    }
  },
  {
    path: 'travelessential/about-macao',
    redirect: {
      path: 'travelessential',
      hash: 'about-macao'
    }
  },
  {
    path: 'travelessential/before-you-travel/travel-agencies',
    name: 'TravelAgencyMain',
    component: TravelAgencyMainView
  },
  {
    path: 'travelessential/before-you-travel/ports-of-entry',
    name: 'BorderCheckpoints',
    component: BorderCheckpointsView
  },
  {
    path: 'travelessential/useful-info/brochures',
    name: 'Brochures',
    component: BrochuresView
  },
  {
    path: 'travelessential/useful-info/tourist-information',
    name: 'TouristInformation',
    component: TouristInformationView
  },
  {
    path: 'travelessential/useful-info/msar-delegations',
    name: 'Delegation',
    component: DelegationView
  },
  {
    path: 'travelessential/useful-info/mgto-representatives',
    name: 'Representative',
    component: RepresentativeView
  },
  {
    path: 'travelessential/before-you-travel/:slug',
    name: 'TravelEssentialArticle_before-you-travel',
    component: createTravelEssentialArticleView('before-you-travel')
  },
  {
    path: 'travelessential/about-macao/:slug',
    name: 'TravelEssentialArticle_about-macao',
    component: createTravelEssentialArticleView('about-macao')
  },
  {
    path: 'travelessential/useful-info/:slug',
    name: 'TravelEssentialArticle_useful-info',
    component: createTravelEssentialArticleView('useful-info')
  },
  {
    path: 'article',
    component: {
      name: 'ArticleWrapper',
      render: function(h) {
        return <router-view />
      }
    },
    children: [
      {
        path: '',
        redirect: '/'
      },
      {
        path: ':slug',
        name: 'Article',
        component: ArticleView
      },
      { //redirect travel essentail category
        path: 'before-you-travel/:slug',
        redirect: '/travelessential/before-you-travel/:slug'
      },
      { //redirect travel essentail category
        path: 'about-macao/:slug',
        redirect: '/travelessential/about-macao/:slug'
      },
      { //redirect travel essentail category
        path: 'useful-info/:slug',
        redirect: '/travelessential/useful-info/:slug'
      },
      {
        path: 'taste-of-macao/:slug',
        redirect: '/dining/taste-of-macao/:slug'
      },
      {
        path: ':category/:slug',
        name: 'ArticleWithCategory',
        component: ArticleWithCategoryView
      }
    ]
  },
  {
    path: 'dining',
    component: DiningView,
    children: [
      {
        path: '',
        name: 'DiningMain',
        component: DiningMainView,
      },
      {
        path: 'restaurant',
        name: 'DiningSearchAllRestaurant',
        component: DiningSearchAllRestaurantView
      },
      {
        path: ':slug',
        name: 'DiningArticle',
        component: ArticleView
      },
      {
        path: ':category/:slug',
        name: 'DiningArticleWithCategory',
        component: ArticleWithCategoryView
      }
    ]
  },
  {
    path: 'accommodation',
    component: AccommodationView,
    children: [
      {
        path: '',
        name: 'AccommodationMain',
        component: AccommodationMainView,
      }
    ]
  },
  // {
  //   path: 'video-playlists',
  //   component: {
  //     name: 'video-wrapper',
  //     render: function(h) {
  //         return <router-view />
  //     }
  //   },
  //   children: [
  //     {
  //       path: '',
  //       meta: { replace: true },
  //       name: 'VideoGalleryDefault',
  //       component: VideoGalleryView
  //     },
  //     {
  //       path: ':vid',
  //       name: 'VideoGallery',
  //       component: VideoGalleryView
  //     }
  //   ]
  // },
  {
    path: 'video-playlists/:playlistId?',
    name: 'VideoPlaylists',
    component: VideoPlaylistsView
  },
  {
    path: 'videogallery/:playlistId?',
    redirect: to => {
      return {
        // path: 'video-playlists/' + (to.params.playlistId || ''),
        path: 'video-playlists',
      };
    },
  },
  {
    path: 'whatson',
    name: 'Whatson',
    component: WhatsonView,
  },
  {
    path: 'whatson/download',
    name: 'WhatsonDownload',
    component: WhatsonDownloadView
  },

  {
    path: 'redirecting',
    name: 'RedirectTo',
    component: RedirectToView
  }
]

export function createMainRoutes(previewProfile) {
  const isBeta = previewProfile === 'beta-m';
  if (!isBeta && previewProfile !== 'staging') return mainRoutes;

  const routes = mainRoutes.map(route => (
    isBeta && route.name === 'Whatson'
      ? { ...route, meta: { ...route.meta, showAllWhatsonMonths: true } }
      : route
  ));
  routes.push({
    path: 'halal-travel-guide',
    name: 'HalalTravelGuide',
    component: HalalTravelGuideView
  });
  return routes;
}
